
import Vue from 'vue'
import maskEntity from './main.vue'


let helpMask, vmInstance = null
let helpMaskConstructor = Vue.extend(maskEntity)


helpMask = (options) => {
    helpMask.open(options)
}


helpMask.open = (options) => {
    if (!vmInstance) {
        vmInstance = new helpMaskConstructor().$mount()
        document.body.appendChild(vmInstance.$el)
        vmInstance.onClose = options.onClose || null
        vmInstance.showing = true
    }
}


helpMask.outerClose = () => {
    vmInstance.showing = false
}


helpMask.close = () => {
    document.body.removeChild(vmInstance.$el)
    // document.getElementsByTagName('body')[0].style.overflow = 'auto'
    vmInstance = null
}


export default helpMask


// WEBPACK FOOTER //
// ./src/components/uimask/src/main.js